import { Link } from "react-router-dom";

// Official The PilCoo Foundation logo (supplied brand assets in /public/brand/).
// logo-header.webp = colour mark + dark text (light backgrounds)
// logo-footer.webp = colour mark + white text (dark backgrounds)
export default function Logo({ dark = false }) {
  return (
    <Link
      to="/"
      className="flex items-center"
      data-testid="nav-logo"
      aria-label="The PilCoo Foundation — home"
    >
      <img
        src={dark ? "/brand/logo-footer.webp" : "/brand/logo-header.webp"}
        alt="The PilCoo Foundation"
        className="h-8 md:h-9 w-auto"
      />
    </Link>
  );
}
